import { useState } from "react";
import { format } from "date-fns/format";

import MonthPickerInput from "./MonthPickerInput";

const MonthPickerInputContainer = ({
  disabled,
  inputRef,
  value,
  component,
  defaultMonth,
  onChange,
  ...restProps
}) => {
  const DEFAULT_DATE_FORMAT = "yyyy-MM";

  const [popoverOpen, setOpenPopover] = useState(false);

  const handleMonthSelect = (nextDate) => {
    if (onChange && nextDate) {
      onChange(format(nextDate, DEFAULT_DATE_FORMAT));
    }

    setOpenPopover(false);
  };

  const handleCalendarClick = () => {
    console.log(popoverOpen);
    setOpenPopover(!popoverOpen);
  }

  const formattedInputValue = value ? format(value, "MMMM yyyy") : "";

  return (
    <MonthPickerInput
      disabled={disabled}
      value={value}
      component={component}
      formattedInputValue={formattedInputValue}
      popoverOpen={popoverOpen}
      onMonthSelect={handleMonthSelect}
      onCalendarClick={handleCalendarClick}
      {...restProps}
    />
  );
};

export default MonthPickerInputContainer;
